export const TIMEOUT = 60 * 1000;
export const MAX_RESEND_SMS_DELAY_IN_SECOND = 60;
export const MAX_TOO_MANY_WRONG_INPUT_WAITING_TIME_IN_SECOND = 60 * 5;
export const DEADLINE_TRANSFER_IN_DAYS = 1;
export const DEADLINE_INTERNATIONAL_TRANSFER_IN_HOURS = 6;
export const DEADLINE_ACCEPT_MONEY_TRANSFER_IN_SECONDS = 3600;
export const SECOND = {
  ONE: 1000,
  TWO: 2000,
};
export const GET_ACCOUNT_TIMEOUT = 5000;
export const REAL_TIME_OVERLAY_LOADING = 3000;
export const REMOTE_CONFIG_FETCH_INTERVAL_IN_MINUTES = 360;
